import React from 'react'
import logo from '../images/qvorLeaf.svg'
import { BsInfoSquare } from 'react-icons/bs'
import {MdOutlineLanguage} from 'react-icons/md'

const Header = ({info, isEng, setIsEng, showAllergens, handleShowInfoClick, handleShowAllergensClick}) => {
   
    let objectVariation = info[0].variation
    let objectVariationEng = info[0].variation_eng
    console.log(showAllergens)
    console.log(handleShowAllergensClick)
    console.log(handleShowInfoClick)
    return (
        <header className="w-full flex h-14 bg-[#F6F4EB] border-b-2 border-b-greenOne justify-center" >
            <div className="w-full max-h-full p-l-1 p-b-1 flex  justify-between ml-2">
                <div className='flex justify-start'>
                    <div>
                        <img className='w-[60px] h-full object-cover block' src={logo} />
                    </div>
                    <div className='text-blueThree font-serif cursive ml-1 p-1 flex flex-row items-center'>
                    <div className='-mt-7 text-xl '>
                            <p className=' text-blueThree italic text-lg'> {objectVariation} </p>
                        </div>
                        <h1 className='text-2xl -ml-10 pt-5'>Малкия Явор</h1>                     
                       

                    </div>
                </div>
                <div className='flex justify-center items-center mr-3'>
                    <div className='mr-14 cursor-pointer text-xl text-red border-2 border-b-red rounded-md'
                        onClick={() => handleShowAllergensClick()}
                    > <p className='p-1'>Алергени! </p></div>
                    
                    <BsInfoSquare 
                        onClick={() => handleShowInfoClick()}
                    className='text-greenTwo cursor-pointer z-10' size={35} />
                  
                    {/* <div className='ml-4 text-2xl cursor-pointer'>
                            <h1>Eng</h1>
                    </div> */}
                </div>
            </div>


        </header>
    )
}

export default Header